<template>

  <v-container fill-height fluid>
    <v-row :no-gutters="true" style="height: 100%">
      <v-col cols="12">

        <v-card tile style="height: 100%; z-index: 100">
          

          <v-container fill-height class="borda-verde_" fluid pa-0>
            <v-row :no-gutters="true" class="borda-azul_" style="height: 100%">

              <v-col class="borda-vermelha_" style="flex-basis: 30%; height: 100%; border-right: 1px solid rgba(0, 0, 0, 0.12)">
                <v-card tile flat style="height: 100%">

                  <v-toolbar flat>
                    <v-app-bar-nav-icon></v-app-bar-nav-icon>

                    <v-toolbar-title>New Chat</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon>
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-divider></v-divider>

                  <v-list subheader>
                    <v-subheader>Recent chat</v-subheader>

                    <v-list-item v-for="item in items" :key="item.title" @click="">
                      <v-list-item-avatar>
                        <v-img :src="item.avatar"></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-icon>
                        <v-icon :color="item.active ? 'deep-purple accent-4' : 'grey'">chat_bubble</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list>

                  <v-divider></v-divider>

                  <v-list subheader>
                    <v-subheader>Previous chats</v-subheader>

                    <v-list-item v-for="item in items2" :key="item.title" @click="">
                      <v-list-item-avatar>
                        <v-img :src="item.avatar"></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title v-text="item.title"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>

                </v-card>
              </v-col>
                
              <v-col style="flex-basis: 70%;" class="borda-vermelha_">
                <v-card tile flat style="height: 100%">
                  <v-toolbar flat>
                    <v-toolbar-title class="grey--text">Title</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon>
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>

                    <v-btn icon>
                      <v-icon>mdi-apps</v-icon>
                    </v-btn>

                    <v-btn icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-divider></v-divider>

                  <v-card-text  class="grey lighten-3 borda-vermelha_" style="height: calc(100% - 64px - 52px)">fsdfsdf</v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                    <v-btn flat>text</v-btn>
                    <v-btn flat color="primary">text</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="show = !show">
                      <v-icon>{{ show ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                    </v-btn>
                  </v-card-actions>

                </v-card>
              </v-col>

              
            </v-row>
          </v-container>


        </v-card>

      </v-col>
    </v-row>

  </v-container>

  
</template>

<script>
  import { mapMutations } from "vuex";
  export default {
    name: 'teste',
    components: {},
    data() {
      return {
        data: null,
        items: [
          { active: true, title: 'Jason Oner', avatar: 'https://cdn.vuetifyjs.com/images/lists/1.jpg' },
          { active: true, title: 'Ranee Carlson', avatar: 'https://cdn.vuetifyjs.com/images/lists/2.jpg' },
          { title: 'Cindy Baker', avatar: 'https://cdn.vuetifyjs.com/images/lists/3.jpg' },
          { title: 'Ali Connors', avatar: 'https://cdn.vuetifyjs.com/images/lists/4.jpg' },
        ],
        items2: [
          { title: 'Travis Howard', avatar: 'https://cdn.vuetifyjs.com/images/lists/5.jpg' },
        ],
      }
    },
    mounted() {
      this.setTitulo('Home');
    },
    methods: {
      ...mapMutations(['setTitulo']),
    }
  }
</script>

<style scoped>
  .input-trasparente >>> .v-input__slot {
    background: none;
  }
</style>
